module.exports = __webpack_public_path__ + "img/thumb-natures-eats@2x.bc524ce0.png";